function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Octicon, { Eye, IssueOpened, RepoForked, Star } from '@githubprimer/octicons-react';
import Dependencies from '../Dependencies/Dependencies';
import SupportLinks from '../SupportLinks/SupportLinks';
import Tooltip from '@homeaway/react-tooltip';
import { ButtonLink } from '@homeaway/react-buttons';
import { SVGIcon } from '@homeaway/react-svg';
import { CHEVRON_DOWN__16 } from '@homeaway/svg-defs';
import edapWrapper from '@homeaway/edap-wrapper';
import "./RepoInfo.css";
var DATE_OPTIONS = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric'
};
var STAT_ICONS = {
  forks: {
    icon: RepoForked,
    tooltip: 'Forks',
    count: 0
  },
  issues: {
    icon: IssueOpened,
    tooltip: 'Open Issues',
    count: 0
  },
  stargazers: {
    icon: Star,
    tooltip: 'Stars',
    count: 0
  },
  watchers: {
    icon: Eye,
    tooltip: 'Watchers',
    count: 0
  }
};

var RepoInfo = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RepoInfo, _Component);

  function RepoInfo() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      expanded: false
    };

    _this.toggleExpansion = function () {
      var newExpanded = !_this.state.expanded;

      _this.setState({
        expanded: newExpanded
      });
    };

    _this.repoClickEvent = function (event) {
      /* istanbul ignore next */
      edapWrapper().push({
        name: 'generic.click',
        data: {
          eventaction: 'repo.view',
          eventlabel: event.currentTarget.href
        }
      });
    };

    return _this;
  }

  var _proto = RepoInfo.prototype;

  _proto.renderStat = function renderStat(stat) {
    var icon = stat.icon,
        count = stat.count,
        tooltip = stat.tooltip;
    return /*#__PURE__*/React.createElement(Tooltip, {
      centered: true,
      content: tooltip
    }, /*#__PURE__*/React.createElement("figure", {
      className: "media-flex__figure media-flex--centered"
    }, /*#__PURE__*/React.createElement(Octicon, {
      icon: icon,
      className: "RepoInfo__stat-icon",
      ariaLabel: tooltip,
      size: "small",
      verticalAlign: "middle"
    }), /*#__PURE__*/React.createElement("p", {
      className: "RepoInfo__stat-count small"
    }, count)));
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        url = _this$props.url,
        name = _this$props.name,
        owner = _this$props.owner,
        dependencies = _this$props.dependencies,
        peerDependencies = _this$props.peerDependencies,
        support = _this$props.support,
        tagDate = _this$props.tagDate,
        tagName = _this$props.tagName;
    var expanded = this.state.expanded;
    var repoClassname = classnames('RepoInfo', {
      'RepoInfo--expanded': expanded
    });
    var depsClassname = classnames('RepoInfo__deps', {
      'RepoInfo__deps--expanded': expanded
    });
    var lastUpdate;
    /* istanbul ignore next */

    if (tagDate) {
      var date = new Date(tagDate);

      if (!isNaN(date.getTime())) {
        lastUpdate = date.toLocaleDateString('en-US', DATE_OPTIONS);
      }
    }

    Object.keys(STAT_ICONS).forEach(function (stat) {
      STAT_ICONS[stat].count = _this2.props[stat];
    });
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("section", {
      className: repoClassname
    }, /*#__PURE__*/React.createElement("p", {
      className: "small no-margin"
    }, /*#__PURE__*/React.createElement("strong", null, owner), /*#__PURE__*/React.createElement("span", {
      className: "pull-right RepoInfo__tag"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      content: "Updated " + lastUpdate,
      centered: true
    }, /*#__PURE__*/React.createElement("span", {
      className: "label label-success"
    }, tagName)))), /*#__PURE__*/React.createElement("h3", {
      className: "RepoInfo__repo-name"
    }, /*#__PURE__*/React.createElement("a", {
      href: url,
      className: "RepoInfo__link",
      onClick: this.repoClickEvent,
      target: "_blank"
    }, name)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ButtonLink, {
      className: "RepoInfo__toggle",
      label: this.renderDependencyHeading,
      onClick: this.toggleExpansion
    }))), /*#__PURE__*/React.createElement("div", {
      className: "RepoInfo__footer"
    }, /*#__PURE__*/React.createElement("div", {
      className: depsClassname
    }, /*#__PURE__*/React.createElement(Dependencies, {
      direct: dependencies,
      peer: peerDependencies
    }), /*#__PURE__*/React.createElement("div", {
      className: "RepoInfo__stats media-flex media-flex--left text-muted"
    }, this.renderStat(STAT_ICONS.stargazers), this.renderStat(STAT_ICONS.forks), this.renderStat(STAT_ICONS.watchers), this.renderStat(STAT_ICONS.issues))), support && /*#__PURE__*/React.createElement(SupportLinks, {
      contact: support.contact,
      issues: support.issues
    })));
  };

  _createClass(RepoInfo, [{
    key: "renderDependencyHeading",
    get: function get() {
      var heading = this.state.expanded ? 'Hide component details' : 'Show component details';
      return /*#__PURE__*/React.createElement("span", {
        className: "RepoInfo__collapse-header text-link"
      }, heading, ' ', /*#__PURE__*/React.createElement(SVGIcon, {
        className: "RepoInfo__chevron",
        markup: CHEVRON_DOWN__16,
        inlineFlex: true
      }));
    }
  }]);

  return RepoInfo;
}(Component);

RepoInfo.propTypes = {
  /** Repo name, example @homeaway/react-foo */
  name: PropTypes.string,

  /** Github organization that owns this component, example: ui-toolkit */
  owner: PropTypes.string,

  /** Github URL. */
  url: PropTypes.string,

  /** Number of forks of this repo */
  forks: PropTypes.number,

  /** Number of open Github issues related to this repo */
  issues: PropTypes.number,

  /** Number of stars on Githbub. */
  stargazers: PropTypes.number,

  /** Number of Github repo watchers. */
  watchers: PropTypes.number,

  /** Flag to control if the Dropdown is open via an external state management. */
  open: PropTypes.bool,

  /** The repo dependencies */
  dependencies: PropTypes.object,

  /** The repo dependencies */
  peerDependencies: PropTypes.object
};
RepoInfo.defaultProps = {
  forks: 0,
  issues: 0,
  stargazers: 0,
  watchers: 0
};
export default RepoInfo;
//# sourceMappingURL=RepoInfo.js.map